import React from 'react';
import AprovacaoPOSearch from './search';
import ButtonOptions from '../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../components/NovoSistema/HeaderButtons';

export default function AprovacaoPO() {
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions buttonName="Manual" border="#333F50" />
      </HeaderButtons>
      <AprovacaoPOSearch />
    </main>
  );
}
